'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'

const navLinks = [
  { label: 'Features', href: '/#features' },
  { label: 'Tools', href: '/#tools' },
  { label: 'How it works', href: '/#how-it-works' },
  { label: 'Integration', href: '/#integration' },
]

const pageLinks = [
  { label: 'Docs', href: '/docs' },
  { label: 'Terms', href: '/docs#terms-of-service' },
  { label: 'Privacy', href: '/privacy' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div className="sticky top-2 z-50 px-3">
      <nav
        className={`relative rounded-2xl border transition-all duration-500 ${
          scrolled
            ? 'border-white/[0.08] bg-navy-900/85 backdrop-blur-2xl shadow-2xl shadow-black/30'
            : 'border-transparent bg-navy-900/50 backdrop-blur-xl shadow-lg shadow-black/10'
        }`}
      >
        {/* Accent line */}
        <div className={`absolute top-0 inset-x-[8%] h-px bg-gradient-to-r from-transparent via-orange-500/50 to-transparent transition-opacity duration-500 ${scrolled ? 'opacity-100' : 'opacity-0'}`} />

        <div className="flex items-center justify-between px-5 py-3 md:px-6">
          <Link
            href="/"
            className="group flex items-center gap-2.5 text-[17px] font-bold tracking-tight text-white transition-opacity duration-200 hover:opacity-80"
          >
            <span className="bg-gradient-to-r from-orange-400 to-orange-500 bg-clip-text text-transparent">TPConnects</span>
            
          </Link>

          <div className="hidden items-center gap-0.5 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="cursor-pointer rounded-lg px-3.5 py-2 text-[13px] font-medium text-slate-400 transition-all duration-200 hover:text-white hover:bg-white/[0.04] active:scale-[0.97]"
              >
                {link.label}
              </a>
            ))}
            {pageLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="cursor-pointer rounded-lg px-3.5 py-2 text-[13px] font-medium text-slate-400 transition-all duration-200 hover:text-white hover:bg-white/[0.04] active:scale-[0.97]"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <Link
            href="/#get-started"
            className="cursor-pointer rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 px-5 py-2 text-[13px] font-semibold text-white shadow-md shadow-orange-500/20 transition-all duration-300 hover:shadow-lg hover:shadow-orange-500/30 hover:-translate-y-px active:translate-y-0 active:shadow-sm"
          >
            Get started
          </Link>
        </div>
      </nav>
    </div>
  )
}
